export default __webpack_public_path__ + "img/bc2a58c98d38c3716caab70b1098b040.png";